function fireCustomGA4Event(eventName, parameters) {
  if (gtag) {
    if (parameters && typeof parameters === "string") {
      parameters = JSON.parse(parameters.replaceAll("'", '"'));
    }
    gtag("event", eventName, parameters);
    console.log(
      `[TRACKING] "${eventName}" with parameters:`,
      JSON.stringify(parameters),
    );
  }
}

function getValuesByAttribute(attributeName) {
  const resultValues = [];
  window.quizResultData.content.forEach((content) => {
    content.answers.forEach((answer) => {
      answer.mappings.forEach((mapping) => {
        attribute = mapping.attribute;

        if (attribute.toUpperCase() === attributeName.toUpperCase()) {
          mapping.values.forEach((value) => {
            resultValues.push(value);
          });
        }
      });
    });
  });
  return resultValues;
}

function handleInvalidUuid() {
  if (Shopify.designMode != true) {
    alert("Your quiz results could not be processed.");
    window.location.href = "/";
  }
}

class QuizResultProductCard extends HTMLElement {
  constructor() {
    super();

    this.firstVariantQuizMainAttribute =
      this.dataset.firstVariantQuizMainAttribute;

    this.variants = this.querySelectorAll("quiz-result-product-card-variant");
    this.compareAtPriceElements = this.querySelectorAll(
      ".quiz-result-product-card__price-table-compare-at-price, .quiz-result-product-card__compare-at-price",
    );
    this.priceElements = this.querySelectorAll(
      ".quiz-result-product-card__price-table-price, .quiz-result-product-card__price",
    );
    this.savingsEl = this.querySelector(
      ".quiz-result-product-card__price-table-savings",
    );

    this.totalCardsEl = this.querySelector("[data-amount-total-cards]");

    this.atcButton = this.querySelector(".quiz-result-product-card__atc");

    this.registerListeners();
  }

  updatePriceSummary() {
    const currentActiveVariant = this.querySelector(
      "quiz-result-product-card-variant[data-selected='true']",
    );
    const currentPrice = currentActiveVariant.dataset.priceStr;
    const compareAtPrice = currentActiveVariant.dataset.compareAtPriceStr;

    if (compareAtPrice == null || compareAtPrice == "") {
      this.savingsEl.setAttribute("data-show", false);
    }

    this.priceElements.forEach((priceElement) => {
      priceElement.textContent = currentPrice;
    });
    this.compareAtPriceElements.forEach((compareAtPriceElement) => {
      compareAtPriceElement.textContent = compareAtPrice;
    });
  }

  registerListeners() {
    this.addEventListener("quiz-result-data-fetched", () => {
      const neededAmount = this.calculateNeededAmount();

      this.showOrHideBasedOnResultData();

      if (this.dataset.show === "false") {
        return;
      }

      let recommendedAmount = neededAmount;
      const variantsContainingAmountForUpsell = Array.from(this.variants)
        .filter((variant) => variant.type === "UPSELL")
        .some(
          (variant) =>
            variant.extractVariantTitleNumbers() == recommendedAmount,
        );

      if (!variantsContainingAmountForUpsell) {
        Array.from(this.variants)
          .filter((variant) => variant.type === "UPSELL")
          .reverse()
          .forEach((variant) => {
            const variantAmount = variant.extractVariantTitleNumbers();
            if (variantAmount > neededAmount) {
              recommendedAmount = variantAmount;
            }
          });
      }

      console.log(
        "Recommended amount is",
        recommendedAmount,
        "Needed amount is: " + neededAmount,
      );

      this.variants.forEach((variant) => {
        if (variant.dataset.type === "BASE") {
          variant.showOrHideBasedOnAmount(neededAmount);
        } else {
          variant.showOrHideBasedOnAmount(recommendedAmount);
        }
      });

      // If no matching variant could be found
      const currentActiveVariant = this.querySelector(
        "quiz-result-product-card-variant[data-selected='true']",
      );

      if (currentActiveVariant == undefined || currentActiveVariant == null) {
        alert(
          "Leider konnten wir keine passenden Varianten finden. Bitte versuchen Sie es erneut.",
        );
        //window.location.href = "/";
        return;
      }

      this.updatePriceSummary();
      const totalCards = currentActiveVariant.extractVariantTitleNumbers();
      this.totalCardsEl.textContent = totalCards;
    });

    this.atcButton.addEventListener("click", () => {
      this.addToCart();
    });
  }

  async addToCart() {
    const currentActiveVariant = this.querySelector(
      "quiz-result-product-card-variant[data-selected='true']",
    );
    const variantId = currentActiveVariant.dataset.variantId;
    const cartDrawer = document.querySelector("cart-drawer");

    const searchParams = new URLSearchParams();
    searchParams.set(
      "sections",
      cartDrawer
        .getSectionsToRender()
        .map((section) => section.id)
        .join(","),
    );
    searchParams.set("sections_url", window.location.pathname);

    const fetchRes = await fetch(
      window.Shopify.routes.root + "cart/add.js?" + searchParams.toString(),
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
            },
          ],
        }),
      },
    );

    if (!fetchRes.ok) {
      this.submitButton.setAttribute("data-loading", false);
      alert("Something went wrong. Please try again.");
      Shopify.analytics.publish("quiz_result_add_to_cart_error");
      return;
    }

    const jsonResponse = await fetchRes.json();

    cartDrawer.renderContents(jsonResponse);
    if (cartDrawer.classList.contains("is-empty"))
      cartDrawer.classList.remove("is-empty");
  }

  calculateNeededAmount() {
    const mainValue = getValuesByAttribute("MAIN")[0];

    if (mainValue === "CLOTHES_MOTHS") {
      const carpetSize = getValuesByAttribute("SIZE_CARPET");
      const furnitureSize = getValuesByAttribute("SIZE_FURNITURE");

      if (carpetSize.length > 0) {
        return parseInt(carpetSize[0]);
      }

      if (furnitureSize.length > 0) {
        return parseInt(furnitureSize[0]);
      }

      const drawerAmount = parseInt(
        getValuesByAttribute("SIZE_DRAWER_AMOUNT_WARDROBE")[0],
      );
      const wardrobeStock = getValuesByAttribute("WARDROBE_STOCK")[0];

      let wardrobeStockMultiplicator = 1;

      if (wardrobeStock === "MEDIUM") {
        wardrobeStockMultiplicator = 2;
      } else if (wardrobeStock === "HIGH") {
        wardrobeStockMultiplicator = 3;
      }

      return drawerAmount * wardrobeStockMultiplicator;
    } else if (mainValue === "FOOD_MOTHS") {
      const drawerFoodAmount = parseInt(
        getValuesByAttribute("SIZE_DRAWER_FOOD_AMOUNT")[0],
      );
      const strengthInfestation = getValuesByAttribute(
        "STRENGTH__INFESTATION=LOW",
      )[0];
      const disposed = getValuesByAttribute("DISPOSED")[0] === "true";

      let multiplier = 1;

      if (strengthInfestation === "MEDIUM" && disposed == true) {
        multiplier = 2;
      }

      if (strengthInfestation === "MEDIUM" && disposed == false) {
        multiplier = 2;
      }

      if (strengthInfestation === "HIGH" && disposed == false) {
        multiplier = 2;
      }

      return drawerFoodAmount * multiplier;
    }
  }

  showOrHideBasedOnResultData() {
    const mainValues = getValuesByAttribute("MAIN");

    if (mainValues.includes(this.firstVariantQuizMainAttribute)) {
      this.setAttribute("data-show", true);
    } else {
      this.setAttribute("data-show", false);
    }
  }
}

customElements.define("quiz-result-product-card", QuizResultProductCard);

class QuizResultProductCardVariant extends HTMLElement {
  constructor() {
    super();

    this.type = this.dataset.type;
    this.variantId = this.dataset.variantId;
    this.variantTitle = this.dataset.variantTitle;
    this.productCard = this.closest("quiz-result-product-card");

    this.registerListeners();
  }

  registerListeners() {
    this.addEventListener("click", () => {
      document
        .querySelectorAll(
          "quiz-result-product-card-variant[data-selected='true']",
        )
        .forEach((variant) => {
          variant.setAttribute("data-selected", false);
        });
      this.setAttribute("data-selected", true);
      this.productCard.updatePriceSummary();
    });
  }

  extractVariantTitleNumbers() {
    return parseInt(this.dataset.quizCardCount);
  }

  extractVariantTitleNumbersAndExtras() {
    return (
      this.extractVariantTitleNumbers() +
      parseInt(this.dataset.quizCardCountExtra)
    );
  }

  showOrHideBasedOnAmount(amount) {
    const variantTitleAmount = this.extractVariantTitleNumbers();
    if (this.type === "BASE") {
      if (amount == variantTitleAmount) {
        this.setAttribute("data-selected", true);
      }
      this.setAttribute("data-show", variantTitleAmount == amount);
      return;
    } else if (this.type === "UPSELL") {
      if (
        amount == variantTitleAmount ||
        amount + 1 == variantTitleAmount ||
        amount + 2 == variantTitleAmount
      ) {
        this.setAttribute("data-show", true);
      } else {
        this.setAttribute("data-show", false);
      }
    }
  }
}

customElements.define(
  "quiz-result-product-card-variant",
  QuizResultProductCardVariant,
);

class QuizResultExpandableItem extends HTMLElement {
  constructor() {
    super();

    this.registerListeners();
  }

  registerListeners() {
    this.addEventListener("click", () => {
      const currentlyExpanded = this.dataset.expanded === "true";
      this.setAttribute("data-expanded", !currentlyExpanded);
    });
  }
}
customElements.define("quiz-result-expandable-item", QuizResultExpandableItem);

class QuizResultProductCardFuture extends HTMLElement {
  constructor() {
    super();
    this.date = this.querySelector(
      ".quiz-result-product-card__future-guarantee-title--highlighted",
    );
    this.date.textContent = this.calculateDateInThreeMonths();
  }

  calculateDateInThreeMonths() {
    const date = new Date();
    date.setMonth(date.getMonth() + 3);
    return date.toLocaleDateString("de-DE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  }
}

customElements.define(
  "quiz-result-product-card-future",
  QuizResultProductCardFuture,
);

class QuizResultPdpSections extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("quiz-result-data-fetched", async () => {
      const mainValues = getValuesByAttribute("MAIN");

      if (mainValues.includes(this.dataset.firstVariantQuizMainAttribute)) {
        const html = await this.fetchAndParsePdpContent();
        html
          .querySelectorAll("section:not(:has([data-section]))")
          .forEach((section) => {
            this.appendChild(section);
          });
      }
    });
  }

  async fetchAndParsePdpContent() {
    const fetchUrl = `/products/${this.dataset.originalProductHandle}`;
    const fetchRes = await fetch(fetchUrl);
    if (!fetchRes.ok) {
      console.error("Could not fetch PDP content");
      return;
    }

    const text = await fetchRes.text();

    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(text, "text/html");
    return htmlDoc;
  }
}

customElements.define("quiz-result-pdp-sections", QuizResultPdpSections);

async function fetchSupabaseQuizResultPageData(uuid) {
  const supabaseUrl =
    "https://isocivdfxhvhqwesgwxv.supabase.co/rest/v1/quiz_result_pages";
  const supabaseSearchParams = new URLSearchParams();
  supabaseSearchParams.set("select", "*");
  supabaseSearchParams.set("uuid", "eq." + uuid);
  const supabaseFetchUrl = supabaseUrl + "?" + supabaseSearchParams.toString();
  const supabaseApiKey =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imlzb2NpdmRmeGh2aHF3ZXNnd3h2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc4MTQ4MTcsImV4cCI6MjA2MzM5MDgxN30.VE2wNOTTytgZ0wgDYTkORbghNbU-65Jz4-xMTkH-aIE";

  const fetchRes = await fetch(supabaseFetchUrl, {
    headers: {
      apikey: supabaseApiKey,
    },
  });

  if (!fetchRes.ok) {
    return null;
  }
  const supabaseData = await fetchRes.json();
  return supabaseData;
}

async function fetchQuizResultData() {
  const currentSearchParams = new URLSearchParams(window.location.search);
  if (!currentSearchParams.has("uuid")) {
    handleInvalidUuid();
    return;
  }
  const uuid = currentSearchParams.get("uuid");

  const supabaseData = await fetchSupabaseQuizResultPageData(uuid);

  if (supabaseData == null || supabaseData.length == 0) {
    handleInvalidUuid();
    return;
  }

  const firstSupabaseResult = supabaseData[0];
  return firstSupabaseResult;
}

fetchQuizResultData().then((result) => {
  window.quizResultData = result;
  document
    .querySelectorAll("quiz-result-product-card,quiz-result-pdp-sections")
    .forEach((card) => {
      card.dispatchEvent(new CustomEvent("quiz-result-data-fetched"));
    });
});
